export enum LicenseStatus {
  all = 'All',
  available = 'Available',
  sold = 'Sold',
  pending = 'Pending',
  expired = 'Expired',
  deleted = 'Deleted',
  seen = 'Seen',
  unSeen = 'UnSeen',
}
export enum SeenStatus {
  all = 'All',
  Seen = 'Seen',
  UnSeen = 'UnSeen',

}
